import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Styled from "@ats/src/views/sessions/components/Styled";
import LoadingIndicator from "@ats/src/components/shared/LoadingIndicator";
import ProfileForm from "./components/ProfileForm";
import FormLogoHeader from "@ats/src/views/sessions/components/FormLogoHeader";
import SessionsLayout from "@ats/src/views/sessions/components/SessionsLayout";
import AdRollScript from "@ats/src/components/shared/AdRollScript";
import { useCurrentSession } from "@ats/src/context/CurrentSessionContext";

function OnboardingProfile(props: any) {
  const { currentOrganizationUser, currentUser } = useCurrentSession();

  const wasInvited = currentOrganizationUser?.role === "org_user" || currentOrganizationUser?.role === "org_admin" || currentOrganizationUser?.role === "org_interviewer";
  const isNewOwner = !wasInvited && currentUser?.createdVia !== "created_via_invite";

  window.logger("%c[OnboardingProfile] RENDER", "color:rgb(25, 210, 81)", {
    props,
    currentOrganizationUser,
    wasInvited,
    isNewOwner,
    adrollExists: !!window.adroll,
  });

  const onComplete = () => {
    props.history.push("/jobs");
  };

  return (
    <SessionsLayout>
      <Styled.FormContentWrapper>
        {props.isLoadingOrganization ? (
          <LoadingIndicator label="Completing profile setup..." />
        ) : (
          <>
            <Styled.Form>
              <Helmet title="Profile" />
              <AdRollScript />
              <FormLogoHeader />
              <h2>Tell us about you</h2>
              <div>
                <ProfileForm
                  onComplete={onComplete}
                  currentOrganization={props.currentOrganization}
                  wasInvited={wasInvited}
                  isNewOwner={isNewOwner}
                  currentUser={currentUser}
                />
              </div>
            </Styled.Form>
            <Styled.Links>
              <Link to="/logout">Log out</Link>
            </Styled.Links>
          </>
        )}
      </Styled.FormContentWrapper>
    </SessionsLayout>
  );
}

OnboardingProfile.defaultProps = {};

export default OnboardingProfile;
